import {Component, OnInit} from '@angular/core';
import {LoaderService} from '../../services/loader/loader.service';

@Component({
    selector: 'app-global-loader',
    templateUrl: './global-loader.component.html',
    styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit {
    isLoading = false;
    customMessage = 'Loading...';

    constructor(private loaderService: LoaderService) {
    }

    ngOnInit(): void {
        this.loaderService.loading$.subscribe((loading) => {
            this.isLoading = loading;
        });
    }

}
